export default {
  unknown: 'Unknown',
  anonymous: 'Anonymous',
  activeCalls: 'All Calls',
} as const;
